// Replace copy-paste Unicode artifacts (smart quotes, exotic spaces, dashes)
// with LaTeX-safe ASCII. pdfTeX's inputenc chokes on characters like U+202F
// (narrow no-break space), which sneak in from Word / AI-generated text.
function normalizeUnicode(s) {
  return s
    // Unicode space separators (incl. U+00A0 nbsp, U+202F narrow nbsp) -> space
    .replace(/[   -   　]/g, ' ')
    // Zero-width characters / BOM -> removed
    .replace(/[​-‍⁠﻿]/g, '')
    // Smart single quotes / prime -> '
    .replace(/[‘’‚‛′]/g, "'")
    // Smart double quotes / double prime -> "
    .replace(/[“”„‟″]/g, '"')
    // Em / en dash -> --- / --
    .replace(/—/g, '---')
    .replace(/–/g, '--')
    // Ellipsis -> ...
    .replace(/…/g, '...')
    // Bullets -> -
    .replace(/[•‣◦⁃∙]/g, '-');
}

// Order matters: backslash must be replaced first.
function escapeToken(s) {
  s = s.replace(/\\/g, '\x00BACKSLASH\x00'); // temporary placeholder
  s = s.replace(/([&%$#_{}])/g, '\\$1');
  s = s.replace(/~/g, '\x00TILDE\x00'); // temporary placeholder
  s = s.replace(/\^/g, '\x00CARET\x00'); // temporary placeholder
  s = s.replace(/\x00BACKSLASH\x00/g, '\\textbackslash{}');
  s = s.replace(/\x00TILDE\x00/g, '\\textasciitilde{}');
  s = s.replace(/\x00CARET\x00/g, '\\textasciicircum{}');
  return s;
}

// TeX only wraps lines at spaces and hyphenation points, so an unbroken run
// of characters longer than a line (pasted URLs, keyboard mash) overflows
// into the margin. Tokens longer than UNBROKEN_LIMIT get invisible break
// opportunities (\allowbreak) every CHUNK raw characters; chunking happens on
// the raw text BEFORE escaping so multi-char escape sequences never split.
const UNBROKEN_LIMIT = 30;
const CHUNK = 20;

export function latexEscape(value) {
  if (value === null || value === undefined) return '';
  const s = normalizeUnicode(String(value));
  return s.split(/(\s+)/).map(tok => {
    if (tok.length <= UNBROKEN_LIMIT || /^\s*$/.test(tok)) return escapeToken(tok);
    const parts = [];
    for (let i = 0; i < tok.length; i += CHUNK) {
      parts.push(escapeToken(tok.slice(i, i + CHUNK)));
    }
    return parts.join('\\allowbreak{}');
  }).join('');
}
